import React from 'react'
import axios from 'axios';
import Button from './Button'


function Coinbase({ userName, cartItems }) {
  const { REACT_APP_API_URL } = process.env;

  // Old crypto code for onClick before disabling it
  // const onClick = () => {
  //   axios.post(
  //     `${REACT_APP_API_URL}/create-payment`,
  //     {
  //       userName,
  //       cartItems,
  //     }
  //   ).then((res) => {
  //     window.open(res.data.hosted_url, '_blank', 'noopener,noreferrer')
  //   })
  // }

  const onClick = () => {
    window.open("https://discord.gg/uXweNEFMnD", "_blank");
  }
  
  return (
    <Button onClick={onClick}>
      <h2>Open a ticket (For PayPal, OSGP, Crypto)</h2>
    </Button>
  )
}

export default Coinbase